import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { ActiveCodesResponse, ApplyAccessCodeResponse } from "./types";

const commerceAccessCodeUrl = `${API_BASE_URL}/commerce/v1/access-code`;

export const applyAccessCode = async ({
	accessCode,
}: {
	accessCode: string;
}): Promise<ApplyAccessCodeResponse> => {
	const { data } = await authAxios.post(commerceAccessCodeUrl, {
		accessCode,
	});

	if (!data.data) {
		throw new Error(data.message);
	}

	return data;
};

export const getActiveAccessCodes = async ({
	sku,
	productId,
}: {
	sku?: string;
	productId?: string;
} = {}): Promise<ActiveCodesResponse[]> => {
	const { data } = await authAxios.get(commerceAccessCodeUrl, {
		params: {
			sku,
			productId,
		},
	});

	return data.data;
};
